function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NodeSetupTemplate = require('./setup.template');
var AdminSetup = /*#__PURE__*/function () {
  function AdminSetup(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-container';
    _classCallCheck(this, AdminSetup);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.selected_app = '';
    this.selected_choice = '';
    this.submitting = false;
    this.showing_recompile = false;
  }
  return _createClass(AdminSetup, [{
    key: "render",
    value: function render() {
      this.app.browser.replaceElementContentBySelector(NodeSetupTemplate(this.mod), this.container);
      this.attachEvents();
      this.updateView();
    }
  }, {
    key: "updateView",
    value: function updateView() {
      var _this = this;
      var root = document.querySelector("".concat(this.container, " .node-setup"));
      if (!root) return;
      var busy = this.submitting || this.showing_recompile;
      root.querySelector('.node-setup-options').hidden = busy;
      root.querySelector('.splash-section').hidden = busy || !this.selected_choice;
      root.querySelector('.node-setup-working').hidden = !this.submitting;
      root.querySelector('.node-setup-dev-info').hidden = !this.showing_recompile || this.selected_choice !== 'development';
      root.querySelector('.node-setup-prod-info').hidden = !this.showing_recompile || this.selected_choice !== 'production';
      root.querySelector('h1').textContent = this.showing_recompile ? 'Ready for Command-Line Recompile' : 'I want to run a:';
      root.querySelectorAll('[data-choice]').forEach(function (button) {
        button.disabled = busy;
        if (button.dataset.choice !== 'existing') {
          button.setAttribute('aria-pressed', String(button.dataset.choice === _this.selected_choice));
        }
      });
      root.querySelectorAll('[data-app]').forEach(function (button) {
        button.disabled = busy || !_this.selected_choice;
        button.classList.toggle('selected', button.dataset.app === _this.selected_app);
      });
    }
  }, {
    key: "showError",
    value: function showError(error) {
      this.submitting = false;
      this.updateView();
      siteMessage('Node setup could not be saved.', 5000);
      salert(error);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelectorAll('.splash-card').forEach(function (card) {
        card.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _this2$mod$server_inf, currentOptions, updatedOptions, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (!(!_this2.selected_choice || _this2.submitting || _this2.showing_recompile)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                _this2.selected_app = card.dataset.app;
                _this2.submitting = true;
                _this2.updateView();
                siteMessage('Customizing your Node Setup...');
                _context.p = 2;
                currentOptions = JSON.parse(JSON.stringify(((_this2$mod$server_inf = _this2.mod.server_info) === null || _this2$mod$server_inf === void 0 ? void 0 : _this2$mod$server_inf.options) || {}));
                updatedOptions = _this2.configureOptionsForChoice(currentOptions, _this2.selected_choice);
                _context.n = 3;
                return _this2.submitOptions(updatedOptions);
              case 3:
                _context.n = 5;
                break;
              case 4:
                _context.p = 4;
                _t = _context.v;
                _this2.showError(_t.message || String(_t));
              case 5:
                return _context.a(2);
            }
          }, _callee, null, [[2, 4]]);
        }));
      });
      var containerEl = document.querySelector(this.container);
      if (containerEl) {
        containerEl.onclick = function (e) {
          var copyBtn = e.target.closest('.admin-copy-cmd');
          if (!copyBtn) {
            return;
          }
          var cmd = copyBtn.dataset.cmd;
          if (cmd) {
            navigator.clipboard.writeText(cmd).then(function () {
              if (typeof siteMessage === 'function') {
                siteMessage('command copied to clipboard...', 2000);
              }
            });
          }
        };
      }
      document.querySelectorAll('.node-setup-card').forEach(function (card) {
        card.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var choice, _t2;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (!(_this2.submitting || _this2.showing_recompile)) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                choice = card.dataset.choice;
                if (!(choice === 'existing')) {
                  _context2.n = 6;
                  break;
                }
                _this2.submitting = true;
                _this2.updateView();
                siteMessage('Saving node setup...');
                _context2.p = 2;
                _context2.n = 3;
                return _this2.submitOptions({
                  isSetupComplete: true
                }, false);
              case 3:
                _context2.n = 5;
                break;
              case 4:
                _context2.p = 4;
                _t2 = _context2.v;
                _this2.showError(_t2.message || String(_t2));
              case 5:
                return _context2.a(2);
              case 6:
                _this2.selected_choice = choice;
                _this2.selected_app = '';
                _this2.updateView();
              case 7:
                return _context2.a(2);
            }
          }, _callee2, null, [[2, 4]]);
        }));
      });
    }
  }, {
    key: "configureOptionsForChoice",
    value: function configureOptionsForChoice(options, choice) {
      options.isSetupComplete = true;
      options.defaultModule = this.selected_app;
      if (choice === 'development') {
        options.consensus = options.consensus || {};
        options.consensus.disable_block_production = false;
        options.consensus.default_social_stake = 0;
        options.consensus.default_social_stake_period = 0;
      }
      if (choice === 'production') {
        options.consensus = options.consensus || {};
        options.consensus.disable_block_production = true;
        options.peers = [{
          host: 'eames.saito.io',
          port: '443',
          protocol: 'https',
          synctype: 'full'
        }];
      }
      return options;
    }
  }, {
    key: "submitOptions",
    value: function () {
      var _submitOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        var _this3 = this;
        var showRecompile,
          tx,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              showRecompile = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
              _context3.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context3.v;
              tx.msg = {
                module: 'Admin',
                request: 'update-options',
                data: options
              };
              _context3.n = 2;
              return tx.sign();
            case 2:
              _context3.n = 3;
              return this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                // Transport failures arrive as plain { err } objects, not transactions.
                var res = typeof res_tx.returnMessage === 'function' ? res_tx.returnMessage() : res_tx;
                if (res !== null && res !== void 0 && res.err) {
                  _this3.showError(res.err);
                  return;
                }
                _this3.submitting = false;
                _this3.mod.server_info = _this3.mod.server_info || {};
                _this3.mod.server_info.options = _objectSpread(_objectSpread({}, _this3.mod.server_info.options), options);
                _this3.showing_recompile = showRecompile;
                if (showRecompile) {
                  _this3.updateView();
                } else {
                  _this3.mod.main.render('overview');
                }
                siteMessage('Node setup saved.', 5000);
              }, this.mod.server_publickey);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function submitOptions(_x) {
        return _submitOptions.apply(this, arguments);
      }
      return submitOptions;
    }()
  }]);
}();
module.exports = AdminSetup;